import React from 'react';

import SinglePageDefaultAnswerIndexContainer  from './answerOptions/singlePageDefaultAnswerIndex/singlePageDefaultAnswerIndexContainer';


const SinglePagePrompt = props => {
    const {prompt, selectedFilters} = props;
    const {id, header, description, question, blurb} = prompt;

    return (
        <div className="prompt">
            {header && (<h2>{header}</h2>)}
            {description && (<p>{description}</p>)}
            <h1 className="question header">{question}</h1>
            <p className="blurb">
                {blurb}
            </p>

            <SinglePageDefaultAnswerIndexContainer prompt={prompt} selectedFilters={selectedFilters} />
        </div>
    );
}

export default SinglePagePrompt;